module.exports = __webpack_public_path__ + "img/145.41776c76.jpg";